// Action keys that open AI Concierge (useActionExecutor aliases import_ai to concierge).
const HANDOFF_LINK = /\[([^\]]+)\]\(action:(concierge|import_ai)\)/g;
const HAS_HANDOFF = /\]\(action:(?:concierge|import_ai)\)/;
// "→ [label](action:concierge)" is always a call to action, also at the end of a sentence.
const ARROW_HANDOFF = /[ \t]*→[ \t]*\[[^\]]+\]\(action:(?:concierge|import_ai)\)/g;

export const hasConciergeHandoff = (content: string): boolean => HAS_HANDOFF.test(content);

/**
 * Pulls the Concierge handoff link out of an assistant reply so it can be shown as a card.
 * An arrow-led link, or a line holding only the link, is dropped; a link inside a
 * sentence keeps its label as plain text, so the sentence still reads.
 * Batch 19: a third of onboarding conversations that offered the inline link never clicked it.
 */
export const extractConciergeHandoff = (
  content: string,
): { content: string; actionKey: string | null } => {
  const matches = Array.from(content.matchAll(HANDOFF_LINK));
  if (matches.length === 0) return { content, actionKey: null };

  const labels = matches.map((m) => m[1].trim());
  const lines = content
    .replace(ARROW_HANDOFF, "")
    .replace(HANDOFF_LINK, "$1")
    .split("\n")
    .filter((line) => {
      const bare = line.replace(/^[\s\-*•→\d.]+/, "").replace(/[*_]/g, "").trim();
      return !labels.includes(bare);
    });
  return { content: lines.join("\n").trim(), actionKey: matches[0][2] };
};
